import type {
  GetCartResponse,
  GetCartRequest,
  AddToCartRequest,
  UpdateCartItemRequest,
  DeleteCartRequest,
  AddToCartResponse,
  UpdateCartItemResponse,
  DeleteCartResponse,
} from '@/infrastructure/cart/utils/types';
import { client } from '../common/client';

class CartAPIClient {
  public async getCart(params?: GetCartRequest): Promise<GetCartResponse> {
    return await client.get('/cart', { params }).then((res) => res.json());
  }

  public async addToCart(payload: AddToCartRequest): Promise<AddToCartResponse> {
    return await client.post('/cart/add', { body: payload }).then((res) => res.json());
  }

  public async updateCartItem({ itemKey, ...payload }: UpdateCartItemRequest): Promise<UpdateCartItemResponse> {
    return await client.put(`/cart/items/${itemKey}`, { body: payload }).then((res) => res.json());
  }

  public async deleteCartItem({ itemKey, ...payload }: DeleteCartRequest): Promise<DeleteCartResponse> {
    return await client
      .delete(`/cart/items/${itemKey}`, {
        body: payload,
      })
      .then((res) => res.json());
  }
}

export const cartAPIClient = new CartAPIClient();
